import React from 'react';
import { graphql, Link } from 'gatsby';
import LitImage from './images/LitImage';
import LitStructuredText from './generic/LitStructuredText';
import HumanHelpModal from './HumanHelpModal';
const ModularHeadingPaths = ({ data }) => {
  const { heading, pathGroup, backgroundColor, negativeTopMargin } = data;

  return (
    <div
      className={`modular-heading-paths-container ${
        negativeTopMargin && 'modular-negative-top-margin'
      }`}
    >
      <div className={`${backgroundColor}`}>
        <div className="modular-global-width modular-text-center modular-padding-small modular-heading-secondary">
          <LitStructuredText data={heading} />
          <div className="path-image-container">
            {/* PurgeCSS include: Yellow-hover-highlight, White-hover-highlight, Black-hover-highlight */}
            {pathGroup.map(
              ({
                isExternalButtonPath,
                pathColour,
                pathContent,
                pathText,
                image,
                isContactModalButton,
              }) => {
                return (
                  <div className={`path-image-inner`}>
                    {isContactModalButton ? (
                      <HumanHelpModal image={image} text={pathText} />
                    ) : (
                      <Link to={pathContent} className={`path`}>
                        <div className="image">
                          <LitImage image={image} />
                        </div>
                        {pathText}
                      </Link>
                    )}
                  </div>
                );
              },
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModularHeadingPaths;
export const fragment = graphql`
  fragment ModularHeadingPaths on DatoCmsHeadingPathGroupBlock {
    id
    backgroundColor
    negativeTopMargin
    heading {
      value
    }

    pathGroup {
      isExternalButtonPath
      isContactModalButton
      pathColour
      pathContent
      pathText
      image {
        gatsbyImageData
      }
    }
    internal {
      type
    }
  }
`;
